"use strict";

if (document.getElementById("app-private-chat")) {
  new Vue({
    delimiters: ['[[', ']]'],
    el: '#app-private-chat',
    data: {
      collapsed: false,
      rooms: {},
      socket: null,
      connected: false,
      currentMessage: 'Votre message...',
      currentRoomName: null,
      visible: false,
      userIsWriting: false,
      timeout: null
    },
    computed: {
      roomLength: function roomLength() {
        return Object.keys(this.rooms).length + ' discussions';
      },
      sortedRooms: function sortedRooms() {
        var _this = this;

        return Object.keys(this.rooms).map(function (key) {
          return _this.rooms[key];
        }).sort(function (a, b) {
          return b.sort_date - a.sort_date;
        });
      }
    },
    mounted: function mounted() {
      CKEDITOR.disableAutoInline = true;
      this.pk = window.lawyer_pk;
      this.session_key = window.session_key;
      this.createSocket();
    },
    methods: {
      collapse: function collapse() {
        this.collapsed = !this.collapsed;
      },
      selectRoom: function selectRoom(data) {
        var room = this.rooms[data.name];
        this.currentRoomName = data.name;
        this.joinRoom(room.name);

        if (!room.read) {
          this.setRead(room.name);
        }
      },
      setRead: function setRead(room_name) {
        this.rooms[room_name].read = true;
        this.socket.send(JSON.stringify({
          'read': true,
          'room': room_name
        }));
      },
      getCurrentMessages: function getCurrentMessages() {
        return this.rooms[this.currentRoomName].messages;
      },
      joinRoom: function joinRoom(roomName) {
        this.socket.send(JSON.stringify({
          'join_room': roomName
        }));
      },
      toggleStatus: function toggleStatus() {
        var setLocal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        this.socket.send(JSON.stringify({
          'toggle': true
        }));

        if (setLocal) {
          localStorage.setItem('gesica-visible', this.visible ? 1 : 0);
        }
      },
      createSocket: function createSocket() {
        var _this2 = this;

        var main = this.$refs.mainPrivate;
        var chat_url = main.dataset.chatUrl;
        this.socket = new WebSocket('wss://chat.' + chat_url + '/ws/chat/' + this.pk + '/');

        this.socket.onopen = function (e) {
          _this2.connected = true;

          if (localStorage.getItem('gesica-visible') && localStorage.getItem('gesica-visible') == 1) {
            _this2.toggleStatus(false);

            _this2.visible = true;
          }
        };

        this.socket.onmessage = function (e) {
          var data = JSON.parse(e.data);

          if (data['room_add']) {
            if (!_this2.rooms.hasOwnProperty(data['room'])) {
              _this2.populateRooms(data);
            }
          }

          if (data['log']) {
            var log = data['log'];
            var user = data['user'];
            var room = data['room'];

            if (log == 'writing' && _this2.currentRoomName == room) {
              _this2.userIsWriting = true;

              if (_this2.timeout) {
                clearTimeout(_this2.timeout);
              }

              _this2.timeout = setTimeout(function () {
                return _this2.userIsWriting = false;
              }, 3000);
            }
          }

          if (data['message']) {
            _this2.rooms[data['room']].messages.push({
              client: data['client'],
              content: data['message'],
              sender: data['sender'],
              timestamp: _this2.getDate(data['timestamp'])
            });

            _this2.$set(_this2.rooms[data['room']], 'timestamp', _this2.setDate(data['timestamp']));

            _this2.$set(_this2.rooms[data['room']], 'sort_date', new Date(data['timestamp']).getTime());

            if (data['room'] != _this2.currentRoomName) {
              _this2.rooms[data['room']].read = false;
            } else {
              _this2.setRead(data['room']);

              if (_this2.timeout) {
                clearTimeout(_this2.timeout);
                _this2.userIsWriting = false;
              }
            }
          }
        };

        this.socket.onclose = function (e) {
          _this2.connected = false;
          console.error('Chat socket closed unexpectedly');
        };
      },
      populateRooms: function populateRooms(data) {
        if (!this.rooms.hasOwnProperty(data['room'])) {
          this.$set(this.rooms, data['room'], {
            name: data['room'],
            client: data['sender'],
            timestamp: this.setDate(data['timestamp']),
            messages: [],
            read: data['read'],
            sort_date: new Date(data['timestamp']).getTime()
          });

          if (!this.currentRoomName) {
            this.currentRoomName = data['room'];
            this.rooms[this.currentRoomName].read = true;
          }
        }
      },
      sendMessage: function sendMessage(e) {
        if (e.keyCode == 13 && !e.shiftKey) {
          e.preventDefault();

          if (this.currentMessage != '') {
            e.srcElement.innerHTML = '';
            this.socket.send(JSON.stringify({
              'message': this.currentMessage,
              'room': this.currentRoomName
            }));
          }
        } else {
          this.currentMessage = e.srcElement.innerHTML;
          this.socket.send(JSON.stringify({
            'writing': true,
            'room': this.currentRoomName
          }));
        }
      },
      sendBtnMessage: function sendBtnMessage() {
        if (this.currentMessage != '') {
          this.socket.send(JSON.stringify({
            'message': this.currentMessage,
            'room': this.currentRoomName
          }));
          this.$refs.contentEditable.innerHTML = "";
        }
      },
      onFocus: function onFocus(e) {
        if (e.srcElement.innerHTML == 'Votre message...') {
          e.srcElement.innerHTML = '';
        }
      },
      onFocusOut: function onFocusOut(e) {
        if (e.srcElement.innerHTML == '') {
          e.srcElement.innerHTML = 'Votre message...';
        }
      },
      getDate: function getDate(dateString) {
        return new moment(dateString).fromNow();
      },
      setDate: function setDate(data) {
        var datetime = this.getDate(data);
        return datetime;
      }
    }
  });
}